import { useI18n } from '../i18n';

/**
 * Shown when the app can't start because Firebase config is missing/invalid.
 * Pure component — imports nothing from Firebase — so it renders even when the
 * Firebase init itself is what failed. Prevents the "blank page" failure mode.
 */
export const ConfigError = ({
  missing,
  detail,
}: {
  missing?: string[];
  detail?: string;
}) => {
  const { t } = useI18n();
  return (
    <div className="auth-screen">
      <div className="auth-card" style={{ textAlign: 'left', maxWidth: '32rem' }}>
        <p className="state-icon" aria-hidden="true" style={{ textAlign: 'center' }}>
          ⚙️
        </p>
        <h1 className="brand-title" style={{ textAlign: 'center' }}>
          {t.config.heading}
        </h1>

        {missing && missing.length > 0 ? (
          <>
            <p className="auth-lead">{t.config.missingIntro}</p>
            <ul className="config-list">
              {missing.map((name) => (
                <li key={name}>
                  <code>{name}</code>
                </li>
              ))}
            </ul>
            <p className="auth-note">
              {t.config.missingHelp(
                <code>.env.example</code>,
                <code>.env.local</code>,
                <code>apiKey</code>,
                <code>appId</code>,
              )}
            </p>
          </>
        ) : (
          <>
            <p className="auth-lead">{t.config.initFailed}</p>
            {detail && <p className="banner banner-error">{detail}</p>}
            <p className="auth-note">
              {t.config.initHelp(
                <code>VITE_FIREBASE_*</code>,
                <code>.env.local</code>,
                <code>VITE_FIREBASE_DATABASE_URL</code>,
              )}
            </p>
          </>
        )}
      </div>
    </div>
  );
};
